import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="border-t border-border bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2">
      <span className="text-sm font-body text-gray-500">
        © {new Date().getFullYear()} Exam Revision
      </span>
      <nav className="flex items-center gap-6" aria-label="Legal">
        <Link to="/privacy" className="text-sm font-body text-gray-500 hover:text-ink transition-colors duration-200">
          Privacy Policy
        </Link>
        <Link to="/terms" className="text-sm font-body text-gray-500 hover:text-ink transition-colors duration-200">
          Terms of Service
        </Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
